
import { CLIENT } from "../constant/actionTypes";

export default (state, action) => {
    if (typeof state === 'undefined') {
        state = [];
    }
    switch (action.type) {
        case CLIENT.SOFTWARE_SUBMODULES.INITIATE:
            return {isFetching: true};
        case CLIENT.SOFTWARE_SUBMODULES.SUCCESS:
            return {isFetching: false, data: action.payload};
        case CLIENT.SOFTWARE_SUBMODULES.ERROR:
            return {isFetching: false, data: action.payload};
        default:
            return state;
    }
};
